import { defineMessages } from 'react-intl';

export default defineMessages({
	backButtonText: {
		defaultMessage: 'Back',
		description: 'Back button text',
		id: 'sd.common.back-button.text',
	},
});
